import { Category } from "common/blockly";
import { Math } from "./Math";
import { Logic } from "./Logic";
import { Control } from "./Control";

export const Common = () => {
  return (
    <>
      <Control />
      <Logic />
      <Math />
      <Category
        name="へんすう"
        categorystyle="variable_category"
        custom="VARIABLE"
        toolboxitemid="variable"
      />

      <Category
        name="かんすう"
        categorystyle="procedure_category"
        custom="PROCEDURE"
        toolboxitemid="procedure"
      />
    </>
  );
};
